// Shapes the Forms and Templates pages for devs, whose lists span every
// company: one group per company, holding that company's rows in the order the
// API sent them. Companies sort by name — a stable, scannable order — and rows
// without one come last under a group of their own rather than dropping off
// the only page that lists them.

export const NO_COMPANY_LABEL = 'No company';

// Anything carrying `company_id` and `company_name`, as forms and templates do.
export const groupByCompany = (items = []) => {
  const companies = new Map();

  items.forEach((item) => {
    // A row pointing at a company that no longer exists comes back without a
    // name, which leaves nothing to file it under.
    const companyId = item.company_name ? item.company_id : null;
    const key = companyId ?? 'none';
    if (!companies.has(key)) {
      companies.set(key, {
        key: `company-${key}`,
        companyId,
        companyName: companyId === null ? NO_COMPANY_LABEL : item.company_name,
        items: [],
      });
    }
    companies.get(key).items.push(item);
  });

  return Array.from(companies.values()).sort((a, b) => {
    if ((a.companyId === null) !== (b.companyId === null)) return a.companyId === null ? 1 : -1;
    return a.companyName.localeCompare(b.companyName);
  });
};

export const groupFormsByCompany = (forms = []) =>
  groupByCompany(forms).map(({ items, ...group }) => ({ ...group, forms: items }));
